module.exports = __webpack_public_path__ + "static/media/discover.70aed5ee.svg";